module.exports = __webpack_public_path__ + "img/logo.d74f8061.svg";